import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import dayjs from "dayjs";
import { OverlayTrigger, Popover, Toast } from "react-bootstrap";
import { Modal, Spin } from "antd";
import AudioPlayer from "../audioPlayer";
import { useCallContext } from "../CallContext";

type Permission = { id: number; name: string };

type Admin = {
  student_id: number;
  summercamp_agent: null;
  SCS_Number: string;
  name: string;
  is_active: boolean;
  branch_name: string;
  orientation_name: string;
  student_class_name: string;
  section_name: string;
  academic_year_name: string;
  no_of_attempts: number;
  button: string;
  agent_name: string;
  is_wizklub_branch: boolean;
  is_offline_branch: boolean;
  is_wizklub_paid_last_year: boolean;
  admission_status_name: string;
  is_wizklub_paid: boolean;
  enrolling_class_name?: string;
};

// type Disposition = {
//   student_disposition_id: number;
//   disposition_name: string;
// };

// type TicketType = {
//   ticket_type_id: number;
//   ticket_type: string;
// };

type Category = {
  category_id: number;
  category_name: string;
};

type SubCategory = {
  subcategory_id: number;
  subcategory_name: string;
};

type Priority = {
  priority_id: number;
  priority_name: string;
};

interface Ticket {
  category?: number | null;
  subcategory?: number | null;
  priority?: number;
  description?: string;
  ticket_id?: number;
  call_back_time?: string | null;
}

interface TicketLog {
  call_logs: any;
  student_name: string;
  description: string;
  category_name: string;
  subcategory_name: string;
  ticket_type_name: string;
  priority_name: string;
  disposition_name: string;
  resolve_notes: string;
  remarks: string;
  call_back_time: string;
  call_start_time: string;
  updated_by_name: string;
  updated_at: string;
  heading: string;
  is_ticket_by_trainer: string
}

interface CallLog {
  agent_name: string;
  call_start_time_: string;
  call_end_time_: string;
  call_duration_hms: string;
  conversation_duration_hms: string;
  caller_status: string;
  destination_status: string;
  call_status: string;
  aws_call_recording_file: string;
  student_name: string;
}

interface ScriptData {
  script_id: number;
  script_name: string;
  script_file: string;
  is_active: boolean;
  script_file_url: string;
  external_url: string;
}

interface ScriptDropdown {
  script_id: number;
  script_name: string;
}

interface Sibiling {
  SCS_Number?: string | null;
  name?: string | null;
  admission_status_name?: string | null;
  branch_name?: string | null;
  orientation_name?: string | null;
  student_class_name?: string | null;
  is_wizklub_paid_last_year?: boolean | null;
  is_wizklub_paid?: boolean | null;

}

interface RelationType {
  id: number;
  name: string;
}

interface Contact {
  id: number;
  student: number;
  relation_type: number;
  relation_type_name: string;
  name: string;
  phone_number: string;
}

interface CallOption {
  id: number;
  student: number;
  label: string;
}

interface TrainerOrAgent {
  is_trainer: string;
}

const AddOrUpdateWizklubTicket = () => {
  const routes = all_routes;
  const location = useLocation();
  // const { id, r1 } = location.state || {};
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const r1 = Number(searchParams.get("r1"));
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [callLoading, setCallLoading] = useState(false);
  const [messageLoading, setMessageLoading] = useState(false);
  const [whatsappLoading, setWhatsappLoading] = useState(false);
  const [data, setData] = useState<Admin[]>([]);
  const [ticketData, setTicketData] = useState<Ticket[]>([]);
  const [trianer_or_agent, setTrainerOrAgent] = useState<TrainerOrAgent | null>(null);
  const [categoriesData, setCategoriesData] = useState<Category[]>([]);
  const [subCategoryData, setSubCategoryData] = useState<SubCategory[]>([]);
  const [priorityData, setPriorityData] = useState<Priority[]>([]);
  const [ticketLogs, setTicketLogs] = useState<TicketLog[]>([]);
  const [previousYearTicketLogs, setPreviousYearTicketLogs] = useState<TicketLog[]>([]);
  const [callLogs, setCallLogs] = useState<CallLog[]>([]);
  const [previousYearCallLogs, setPreviousYearCallLogs] = useState<CallLog[]>([]);
  const [showCallLogs, setShowCallLogs] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showCallHistory, setShowCallHistory] = useState(false);
  const [showTicketLogs, setShowTicketLogs] = useState(true);
  const [showCallBackTime, setShowCallBackTime] = useState(false);
  const { isCalling, setIsCalling } = useCallContext();
  const callBackTimeRef = useRef<HTMLInputElement>(null);
  const [sdata, setsData] = useState<ScriptData[]>([]);
  const [showCard, setShowCard] = useState(false);
  const [scriptDropdown, setScriptDropdown] = useState<ScriptDropdown[]>([]);
  const [selectedScript, setSelectedScript] = useState("");
  const [pdfSrc, setPdfSrc] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [corelationId, setCorelationId] = useState("");
  const [ticketLogLoading, setTicketLogLoading] = useState(false);
  const [callLogLoading, setCallLogLoading] = useState(false);
  const [ticket_id, setTicketId] = useState<number>();
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
  const [isLocked, setIsLocked] = useState<boolean>(true);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [sibiling, setSibiling] = useState<Sibiling[]>([]);

  const [expandedLogs, setExpandedLogs] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [expandedLogs1, setExpandedLogs1] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [selectedCategory, setSelectedCategory] = useState<Option | null>(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState<Option | null>(
    null
  );
  const [selectedPriority, setSelectedPriority] = useState<Option | null>(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [relationTypes, setRelationTypes] = useState<RelationType[]>([]);
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [formData, setFormData] = useState<Partial<Contact>>({
    relation_type: undefined,
    name: "",
    phone_number: "",
  });
  const [editingId, setEditingId] = useState<number | null>(null);
  const [callOptions, setCallOptions] = useState<CallOption[]>([]);
  const [selectedCallId, setSelectedCallId] = useState<string>("");
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const [showPopover, setShowPopover] = useState(false);

  // Popover message for "Save" button if isCalling is true
  const popoverWarning = (
    <Popover id="popover-warning">
      <Popover.Header as="h3">Action Restricted</Popover.Header>
      <Popover.Body>
        The ticket can only be submitted after the call disconnects.
      </Popover.Body>
    </Popover>
  );

  useEffect(() => {
    if (!checkPermission("change_wizklubticket", "wizklubticket")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
      fetchRelationTypes();
      fetchContacts();
      fetchIsTrainerOrAgent();
      fetchPreviousYearCallLogs();
    }
  }, [userPermissions]);

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      const updateCurrentTime = () =>
        setCurrentTime(audioRef.current!.currentTime);
      const updateDuration = () => setDuration(audioRef.current!.duration);

      audioRef.current.addEventListener("timeupdate", updateCurrentTime);
      audioRef.current.addEventListener("loadedmetadata", updateDuration);

      return () => {
        audioRef.current?.removeEventListener("timeupdate", updateCurrentTime);
        audioRef.current?.removeEventListener("loadedmetadata", updateDuration);
      };
    }
  }, []);

  const handleToggleLog = (index: number) => {
    setExpandedLogs((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const handleToggleLog1 = (index: number) => {
    setExpandedLogs1((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  const handleToggleForm = () => {
    setShowForm(true);
    setShowCallLogs(false);
    setShowTicketLogs(false);
    setShowCard(false);
  };

  // const handleToggleCallLogs = async () => {
  //   setShowForm(false);
  //   setShowCallLogs(true);
  //   setShowTicketLogs(false);
  //   setShowCard(false);
  //   setCallLogLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${webApi}/call/student_wise_wizklub_call_logs/${id}/`,
  //       options
  //     );
  //     const data = await response.json();
  //     setCallLogs(data.results);
  //   } catch (error) {
  //     console.error("Error fetching call logs:", error);
  //   } finally {
  //     setCallLogLoading(false);
  //   }
  // };


  const handleToggleCallLogs = async () => {
    setShowForm(false);
    setShowCallLogs(true);
    setShowTicketLogs(false);
    setShowCard(false);
    setCallLogLoading(true);

    try {
      // Fetch both call logs and categories data in parallel
      const results = await Promise.allSettled([
        fetch(`${webApi}/call/student_wise_wizklub_call_logs/${id}/`, options)
          .then(response => response.json()),
        // Fetch categories data using the existing provider data
        (async () => {
          if (newAdmin?.SCS_Number) {
            return await fetchCategoriesData(newAdmin?.SCS_Number || "");
          }
          return null;
        })()
      ]);

      // Handle call logs result
      const callLogsResult = results[0];
      if (callLogsResult.status === 'fulfilled') {
        setCallLogs(callLogsResult.value.results);
      } else {
        console.error("Error fetching call logs:", callLogsResult.reason);
      }

      // Handle categories result
      const categoriesResult = results[1];
      if (categoriesResult.status === 'fulfilled' && categoriesResult.value) {
        setCategoriesData(categoriesResult.value);
      } else {
        // console.error("Error fetching categories data:", categoriesResult.reason);
      }

    } catch (error) {
      console.error("Error in handleToggleCallLogs:", error);
    } finally {
      setCallLogLoading(false);
    }
  };


  const handleToggleTicketLogs = async (ticket_id: number) => {
    setShowForm(false);
    setShowCallLogs(false);
    setShowTicketLogs(true);
    setShowCard(false);
    setTicketLogLoading(true);
    try {
      const response = await fetch(
        `${webApi}/wizklub/wizklub_ticket_logs_by_ticket/${ticket_id}`,
        options
      );
      const data = await response.json();
      setTicketLogs(data.results);
    } catch (error) {
      console.error("Error fetching ticket logs:", error);
    } finally {
      setTicketLogLoading(false);
    }
  };

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    student_id: 0,
    summercamp_agent: null,
    SCS_Number: "",
    name: "",
    is_active: false,
    branch_name: "",
    orientation_name: "",
    student_class_name: "",
    section_name: "",
    academic_year_name: "",
    no_of_attempts: 0,
    button: "Add Ticket",
    is_wizklub_branch: false,
    is_offline_branch: false,
    is_wizklub_paid_last_year: false,
    agent_name: "",
    admission_status_name: "",
    is_wizklub_paid: false
  });

  const [newTicket, setNewTicket] = useState<Ticket>({
    category: undefined,
    subcategory: null,
    priority: undefined,
    description: "",
    call_back_time: null,
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchCallOptions = async () => {
    try {
      const res = await fetch(`${webApi}/students/student_contact_number_dropdown/?student_id=${id}`, options);
      const data: CallOption[] = await res.json();
      setCallOptions(data);
    } catch (error) {
      console.error("Error fetching call options:", error);
    }
  };

  const handleCallButtonClick = () => {
    fetchCallOptions();
  };

  const openModal = (contact?: Contact) => {
    setShowModal(true);
    if (contact) {
      setEditingId(contact.id);
      setFormData({
        relation_type: contact.relation_type,
        name: contact.name,
        phone_number: contact.phone_number,
      });
    } else {
      setEditingId(null);
      setFormData({ relation_type: undefined, name: "", phone_number: "" });
    }
  };

  const handleCustomModelSubmit = async () => {
    if (!formData.relation_type || !formData.phone_number) {
      setToastMessage("Relation type and phone number are required.");
      setShowSolidDangerToast(true);
      setTimeout(() => {
        setShowSolidDangerToast(false);
      }, 3000);
      return;
    }

    const payload = {
      relation_type: formData.relation_type,
      name: formData.name,
      phone_number: formData.phone_number,
    };

    try {
      const url = editingId
        ? `${webApi}/students/get_or_update_student_contacts/${editingId}/`
        : `${webApi}/students/create_student_contacts/${id}/`;

      const method = editingId ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.non_field_errors && errorData.non_field_errors.length > 0) {
          setToastMessage(errorData.non_field_errors[0]);
          setTimeout(() => {
            setShowSolidDangerToast(false);
          }, 3000);
        } else {
          setToastMessage("Failed to save contact. Please try again.");
          setShowSolidDangerToast(true);
          setTimeout(() => {
            setShowSolidDangerToast(false);
          }, 3000);
        }

        return;
      }
      setShowModal(false);
      fetchContacts(); // Refresh contacts
    } catch (error) {
      console.error("Error saving contact:", error);
    }
  };


  const fetchRelationTypes = async () => {
    try {
      const res = await fetch(`${webApi}/students/relationship_type_dropdown/`, options);
      const data: RelationType[] = await res.json();
      setRelationTypes(data);
    } catch (error) {
      console.error("Error fetching relation types:", error);
    }
  };

  const fetchIsTrainerOrAgent = async () => {
    const response = await fetch(`${webApi}/wizklub/is_trainer_or_agent/`, options);
    const data = await response.json()
    setTrainerOrAgent(data);
  };

  const fetchContacts = async () => {
    try {
      const res = await fetch(`${webApi}/students/student_contacts_list/${id}/`, options);
      const data: Contact[] = await res.json();
      setContacts(data);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };



  const toggleLock = async (): Promise<void> => {
    if (isLocked) {
      // Fetch phone number from the API
      try {
        const response = await fetch(
          `${webApi}/students/get_student_phone_number/?scsnumber=${newAdmin.SCS_Number}`,
          options
        );
        const data = await response.json();
        setPhoneNumber(data.mobile_number);
      } catch (error) {
        console.error("Error fetching phone number:", error);
      }
    } else {
      // Hide the phone number
      setPhoneNumber("");
    }
    setIsLocked(!isLocked);
  };

  const fetchProviderData = async (id: string) => {
    const response = await fetch(
      `${webApi}/students/get_wizklub_student_by_id/${id}`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };



  const fetchTicketData = async (id: string) => {
    const response = await fetch(
      `${webApi}/wizklub/ticket_operations/${id}`,
      options
    );
    return await response.json();
  };

  // const fetchDispositionData = async () => {
  //   const response = await fetch(
  //     `${webApi}/summercamp/dispositions_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  const fetchCategoriesData = async (scs_number: string) => {
    const response = await fetch(
      `${webApi}/wizklub/wizklub_categories_dropdown_based_on_student/?scs_number=${scs_number}`,
      options
    );
    return await response.json();
  };

  const fetchSubCategoryData = async (categoryId: number) => {
    const response = await fetch(
      `${webApi}/wizklub/subcategories_by_category/${categoryId}/`,
      options
    );
    return await response.json();
  };

  const fetchPriorityData = async () => {
    const response = await fetch(
      `${webApi}/wizklub/wizklub_priorities_dropdown/`,
      options
    );
    return await response.json();
  };

  // const fetchTypeOfTicketData = async () => {
  //   const response = await fetch(
  //     `${webApi}/wizklub/type_of_tickets_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  const fetchTicketLogs = async (ticket_id: number) => {
    const response = await fetch(
      `${webApi}/wizklub/wizklub_ticket_logs_by_ticket/${ticket_id}`,
      options
    );
    return await response.json();
  };
  const fetchPreviousYearTicketLogs = async (ticket_id: any) => {
    const response = await fetch(
      `${webApi}/wizklub/previous_year_wizklub_ticket_logs_details/${ticket_id}`,
      options
    );
    return await response.json();
  };



  const fetchCallLog = async (id: string) => {
    const response = await fetch(
      `${webApi}/call/student_wise_wizklub_call_logs/${id}`,
      options
    );
    return await response.json();
  };

  const fetchPreviousYearCallLogs = async () => {
    const response = await fetch(
      `${webApi}/call/student_wise_previous_year_wizklub_call_logs/${id}`,
      options
    );
    const data = await response.json();
    setPreviousYearCallLogs(data?.results?.[0]?.call_logs || []);
  };

  const checkCallEnd = async (correlationId: any) => {
    try {
      const response = await fetch(
        `${webApi}/call/is_call_end/?correlation_id=${correlationId}`,
        options
      );
      const data = await response.json();

      if (data.is_call_end) {
        setIsCalling(false);
        await fetch(`${webApi}/user_monitoring/change_agent_status/1/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({}), // Empty JSON object (not a string)
        });
        setCorelationId("")
      }
      // else if (isCalling) {
      //   setTimeout(() => checkCallEnd(correlationId), 1000);
      // }
    } catch (error) {
      console.error("Error fetching call status:", error);
      if (isCalling) { // Check if isCalling is true in case of error
        setTimeout(() => checkCallEnd(correlationId), 5000); // Retry after 5 seconds
      }
    }
  };

  useEffect(() => {
    if (isCalling) {
      setTimeout(() => checkCallEnd(corelationId), 1000);
    }
  });

  const handleCallClick = async () => {
    setCallLoading(true);
    try {
      const response = await fetch(
        `${webApi}/call/wizklub_calling/?scsnumber=${newAdmin.SCS_Number}&student_contact_id=${selectedCallId}`,
        options
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData.detail || responseData.error || "An error occurred";
        setToastMessage(errorMessage);
        setShowSolidDangerToast(true);
        setTimeout(() => setShowSolidDangerToast(false), 3000);
        console.error(errorMessage);
        return; // Exit early if the first call fails
      }

      // First call succeeded
      setIsCalling(true);
      setCallDuration(0);
      setCorelationId(responseData.correlationId);

      if (intervalId) {
        clearInterval(intervalId);
      }

      const id = setInterval(() => {
        setCallDuration((prev) => prev + 1);
      }, 1000);
      setIntervalId(id);

      checkCallEnd(responseData.correlationId);

      // Make the second API call
      const statusResponse = await fetch(
        `${webApi}/user_monitoring/change_agent_status/3/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({}),
        }
      );

      if (!statusResponse.ok) {
        const statusError = await statusResponse.json();
        console.error("Error updating agent status:", statusError);
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Unknown error occurred while calling API";
      setToastMessage(`Error: ${errorMessage}`);
      setShowSolidDangerToast(true);
      setTimeout(() => setShowSolidDangerToast(false), 3000);
      console.error("API call error:", error);
    } finally {
      setCallLoading(false);
    }
  };

  const handleMessageClick = async () => {
    setMessageLoading(true);
    try {
      const response = await fetch(
        `${webApi}/sms/send_wizklub_sms/?scsnumber=${newAdmin.SCS_Number}`,
        options
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData.detail || responseData.error || "An error occurred";
        setToastMessage(errorMessage);
        setShowSolidDangerToast(true);
        setTimeout(() => setShowSolidDangerToast(false), 3000);
        console.error(errorMessage);
        return; // Exit early if the first call fails
      }
      setToastMessage(responseData.message);
      setshowSolidSuccessToast(true);
      setTimeout(() => setshowSolidSuccessToast(false), 3000);
    } finally {
      setMessageLoading(false);
    }
  };

  const handleWhasappClick = async () => {
    setWhatsappLoading(true);
    try {
      const response = await fetch(
        `${webApi}/whatsapp/send_wizklub_whatsapp_message/?scsnumber=${newAdmin.SCS_Number}`,
        options
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData.detail || responseData.error || "An error occurred";
        setToastMessage(errorMessage);
        setShowSolidDangerToast(true);
        setTimeout(() => setShowSolidDangerToast(false), 3000);
        console.error(errorMessage);
        return; // Exit early if the first call fails
      }
      setToastMessage(responseData.message);
      setshowSolidSuccessToast(true);
      setTimeout(() => setshowSolidSuccessToast(false), 3000);
    } finally {
      setWhatsappLoading(false);
    }
  };

  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);

  const handleEndCallClick = async () => {
    setIsCalling(false);
    // Handle call end logic
    await fetch(`${webApi}/user_monitoring/change_agent_status/1/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({}), // Empty JSON object (not a string)
    });
    setCorelationId("");
  };

  const formatLocalDateTimeString = (localDateTime: string): string => {
    // Input: "2025-03-06 07:14:00"
    const [datePart, timePart] = localDateTime.split(" ");
    const [year, month, day] = datePart.split("-");
    const [hours, minutes] = timePart.split(":");

    // Output: "2025-03-06T07:14"
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };


  const fetchData = async () => {
    setIsLoading(true);
    try {
      if (id) {
        // Use Promise.allSettled to handle individual API failures
        const results = await Promise.allSettled([
          fetchProviderData(id),
          fetchTicketData(id),
          fetchPriorityData(),
          fetchCallLog(id),
        ]);

        // Extract values from settled results with proper typing
        const providerResult = results[0];
        const ticketResult = results[1];
        const priorityResult = results[2];
        const callResult = results[3];
        const previousYearTicketLogsData = await fetchPreviousYearTicketLogs(id);
        setPreviousYearTicketLogs(previousYearTicketLogsData?.[0]?.logs || []);
        console.log("Previous Year Ticket Logs:", previousYearTicketLogsData?.[0]?.logs || []);
        let providerData: any = null;
        let ticketData: any = null;
        let priorityData: any = null;

        // Handle each result individually, allowing failures to be ignored
        if (providerResult.status === 'fulfilled') {
          providerData = providerResult.value;
          setData(providerData);
          setNewAdmin(providerData);
          setSibiling(providerData.siblings);
        } else {
          console.error('Error fetching provider data:', providerResult.reason);
        }

        if (ticketResult.status === 'fulfilled') {
          ticketData = ticketResult.value;
          setTicketData(ticketData);
          const student_ticket_id = ticketData.ticket_id;
          setTicketId(student_ticket_id);

          // Fetch ticket logs only if ticket data was successful
          try {
            const ticketLogsData = await fetchTicketLogs(student_ticket_id);
            setTicketLogs(ticketLogsData.results);

          } catch (error) {
            console.error('Error fetching ticket logs:', error);
          }

          setNewTicket(ticketData);

        } else {
          console.error('Error fetching ticket data:', ticketResult.reason);
        }

        if (priorityResult.status === 'fulfilled') {
          priorityData = priorityResult.value;
          setPriorityData(priorityData);

          // Set selected priority only if both ticket and priority data were successful
          if (ticketData) {
            const selectedPriority = priorityData.find(
              (p: { priority_id: any }) => p.priority_id === ticketData.priority
            );
            setSelectedPriority(
              selectedPriority
                ? {
                  value: selectedPriority.priority_id.toString(),
                  label: selectedPriority.priority_name,
                }
                : null
            );
          }
        } else {
          console.error('Error fetching priority data:', priorityResult.reason);
        }

        if (callResult.status === 'fulfilled') {
          setCallLogs(callResult.value.results);
        } else {
          console.error('Error fetching call logs:', callResult.reason);
        }

        // Fetch categories data separately using providerData if available
        try {
          // Use the providerData we extracted earlier, or fetch it separately if needed
          const scsNumber = providerData?.SCS_Number;
          if (scsNumber) {
            const categoryResponse1 = await fetchCategoriesData(scsNumber);
            setCategoriesData(categoryResponse1);

            // Set selected category only if both ticket and category data were successful
            if (ticketData) {
              const selectedCategory = categoryResponse1.find(
                (c: { category_id: any }) => c.category_id === ticketData.category
              );
              setSelectedCategory(
                selectedCategory
                  ? {
                    value: selectedCategory.category_id.toString(),
                    label: selectedCategory.category_name,
                  }
                  : null
              );

              if (selectedCategory) {
                try {
                  const subCategoryDataResponse = await fetchSubCategoryData(
                    selectedCategory.category_id
                  );
                  const selectedSubCategory = subCategoryDataResponse.results.find(
                    (sc: { subcategory_id: any }) => sc.subcategory_id === ticketData.subcategory
                  );
                  setSelectedSubCategory(
                    selectedSubCategory
                      ? {
                        value: selectedSubCategory.subcategory_id.toString(),
                        label: selectedSubCategory.subcategory_name,
                      }
                      : null
                  );
                } catch (error) {
                  console.error('Error fetching subcategory data:', error);
                }
              }
            }
          } else {
            console.warn('SCS_Number not available for fetching categories');
          }
        } catch (error) {
          console.error('Error fetching categories data:', error);
        }

        // Set callback time if ticket data was successful
        if (ticketData) {
          const apiCallBackTime = ticketData.call_back_time_local
            ? formatLocalDateTimeString(ticketData.call_back_time_local)
            : null;

          setNewTicket((prevTicket) => ({
            ...prevTicket,
            call_back_time: apiCallBackTime,
          }));
        }

      } else {
        console.error("ID is undefined");
      }
    } catch (error) {
      console.error("Unexpected error in fetchData:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (newTicket.category && [2, 3].includes(newTicket.category)) {
      setShowCallBackTime(true);
    } else {
      setShowCallBackTime(false);
      // setNewTicket({ ...newTicket, call_back_time: null });
    }
  }, [newTicket]);

  const fetchData1 = async (id: number) => {
    try {
      const response = await fetch(
        `${webApi}/scripting/manage_scripts/${id}/`,
        options
      );
      const result = await response.json();
      if (result.data && result.data.script_file) {
        setPdfSrc(result.data.script_file);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDropdownData = async () => {
    try {
      const response = await fetch(
        `${webApi}/scripting/wizklub_script_dropdown/`,
        options
      );
      const result = await response.json();
      if (Array.isArray(result)) {
        setScriptDropdown(result);
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const handleSelectChange = (event: { target: { value: any } }) => {
    const scriptId = event.target.value;
    setSelectedScript(scriptId);
    fetchData1(scriptId);
  };

  const toggleCard = () => {
    setShowCard(!showCard);
    setShowForm(false);
    setShowCallLogs(false);
    setShowTicketLogs(false);
  };

  const updateData = async () => {
    const requestOptions = {
      method: newAdmin.no_of_attempts === 0 ? "POST" : "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTicket),
    };
    const url = `${webApi}/wizklub/ticket_operations/${newAdmin.student_id}/`;
    try {
      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        const errorData = await response.json();
        setToastMessage(errorData.message);
        setShowSolidDangerToast(true);
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setToastMessage("Ticket updated successfully");
      setshowSolidSuccessToast(true);

      setTimeout(() => {
        setshowSolidSuccessToast(false);
      }, 3000);
      return response;
    } catch (error) {
      console.error("An error occurred:", error);
      setToastMessage("An error occurred while updating data.");
      return null; // ✅ Return null in case of an error
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowSolidDangerToast(false);
    }, 3000);
  }, [toastMessage]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!selectedCategory) {
      setToastMessage("please Select a Category");
      setShowSolidDangerToast(true);
      setTimeout(() => {
        setShowSolidDangerToast(false);
      }, 3000);
      return;
    } else if (!selectedSubCategory) {
      setToastMessage("please Select a Sub Category");
      setShowSolidDangerToast(true);
      setTimeout(() => {
        setShowSolidDangerToast(false);
      }, 3000);
      return;
    }
    setIsLoading1(true);
    try {
      const response = await updateData();
      if (!response || !response.ok) {
        // ✅ Stop execution if update failed
        console.error("Update failed, stopping further execution.");
        return;
      }

      if (newAdmin.no_of_attempts === 0) {
        await fetchData();
        if (typeof ticket_id !== "undefined") {
          handleToggleTicketLogs(ticket_id);
        }
        setShowForm(false);
        setShowTicketLogs(true);
      }

      if (typeof ticket_id !== "undefined") {
        handleToggleTicketLogs(ticket_id);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading1(false);
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    if (name === "call_back_time") {
      const formattedValue = value
        ? dayjs(value).format("YYYY-MM-DD HH:mm:ss")
        : undefined;
      setNewTicket({ ...newTicket, [name]: formattedValue });
      // e.target.blur();
    } else {
      setNewTicket({ ...newTicket, [name]: value || undefined });
    }
  };

  const categoryOptions = categoriesData.map((c) => ({
    value: c.category_id.toString(),
    label: c.category_name,
  }));

  const subCategoryOptions = subCategoryData.map((sc) => ({
    value: sc.subcategory_id.toString(),
    label: sc.subcategory_name,
  }));

  const priorityOptions = priorityData.map((p) => ({
    value: p.priority_id.toString(),
    label: p.priority_name,
  }));

  const handleCategoryChange = async (selected: Option | null) => {
    const category = categoriesData.find(
      (c) => c.category_id === parseInt(selected?.value || "")
    );
    setSelectedCategory(
      category
        ? {
          value: category.category_id.toString(),
          label: category.category_name,
        }
        : null
    );
    setSelectedSubCategory(null);
    setNewTicket({
      ...newTicket,
      category: category?.category_id,
      subcategory: null,
    });

    if (category && [2, 3].includes(category.category_id)) {
      setShowCallBackTime(true);
    } else {
      setShowCallBackTime(false);
      // setNewTicket({ ...newTicket, call_back_time: null });
    }

    if (category) {
      const subCategoryDataResponse = await fetchSubCategoryData(
        category.category_id
      );
      setSubCategoryData(subCategoryDataResponse.results);
    }
  };

  const handleSubCategoryChange = (selected: Option | null) => {
    const subCategory = subCategoryData.find(
      (sc) => sc.subcategory_id === parseInt(selected?.value || "")
    );
    setSelectedSubCategory(
      subCategory
        ? {
          value: subCategory.subcategory_id.toString(),
          label: subCategory.subcategory_name,
        }
        : null
    );
    setNewTicket({
      ...newTicket,
      subcategory: subCategory?.subcategory_id,
    });
  };

  const handlePriorityChange = (selected: Option | null) => {
    const priority = priorityData.find(
      (p) => p.priority_id === parseInt(selected?.value || "")
    );
    setSelectedPriority(
      priority
        ? {
          value: priority.priority_id.toString(),
          label: priority.priority_name,
        }
        : null
    );
    setNewTicket({
      ...newTicket,
      priority: priority?.priority_id,
    });
  };

  useEffect(() => {
    if (newTicket.category) {
      fetchSubCategoryData(newTicket.category).then(
        (subCategoryDataResponse) => {
          setSubCategoryData(subCategoryDataResponse.results);
        }
      );
    }
  }, [newTicket.category]);

  useEffect(() => {
    const fetchPdf = async () => {
      const options = {
        method: "GET",
        // mode: "no-cors" as RequestMode, // Cast to RequestMode
        headers: {
          // "Content-Type": "application/pdf",
          Authorization: `Bearer ${jwtToken}`,
          // "Cache-Control": "no-cache",
        },
      };

      try {
        const response = await fetch(pdfSrc, options);
        if (response.ok) {
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
        } else {
          console.error("Failed to fetch PDF");
        }
      } catch (error) {
        console.error("Error fetching PDF:", error);
      }
    };

    fetchPdf();
  }, [pdfSrc, jwtToken]);

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  const ringingAnimation = `
@keyframes ringing {
  0% { transform: translateY(0); }
  25% { transform: translateY(-2px); }
  50% { transform: translateY(2px); }
  75% { transform: translateY(-2px); }
  100% { transform: translateY(0); }
}
`;

  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(ringingAnimation, styleSheet.cssRules.length);

  const iconStyles = {
    chatScript: {
      fontSize: "24px",
      color: "blue",
      cursor: "pointer",
      marginBottom: "10px",
    },
    leaderboard: {
      fontSize: "24px",
      color: "green",
      cursor: "pointer",
      marginBottom: "10px",
    },
    chat: {
      fontSize: "24px",
      color: "red",
      cursor: "pointer",
      marginBottom: "10px",
    },
  };

  const containerStyle = {
    position: "fixed" as "fixed",
    bottom: "10px",
    right: "10px",
    display: "flex",
    flexDirection: "column" as "column",
    gap: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: Add background for better visibility
    borderRadius: "8px", // Optional: Rounded corners
    padding: "10px", // Optional: Add some padding
  };

  // useEffect(() => {
  //   console.log(newAdmin);
  // });

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Wizklub {newAdmin.button}</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={
                      [1, 2, 3, 4, 5, 9].includes(r1)
                        ? routes.adminDashboard1
                        : routes.wizklubTrainerDashboard
                    }>
                      Dashboard
                    </Link>
                  </li>
                  {r1 === 1 ? (
                    <li className="breadcrumb-item">
                      <Link to={routes.wizklubStudents}>Students</Link>
                    </li>
                  ) : r1 === 2 ? (
                    <li className="breadcrumb-item">
                      <Link to={routes.wizklubPreviousYearPaidStudents}>
                        {" "}
                        Renewal Students(2025-2026)
                      </Link>
                    </li>
                  ) : r1 === 3 ? (
                    <li className="breadcrumb-item">
                      <Link to={routes.wizklubCompletedStudents}>
                        {" "}
                        Completed Students
                      </Link>
                    </li>
                  )
                    : r1 === 4 ? (
                      <li className="breadcrumb-item">
                        <Link to={routes.wizklubSales}>
                          {" "}
                          Sales
                        </Link>
                      </li>
                    ) : r1 === 5 ? (
                      <li className="breadcrumb-item">
                        <Link to={routes.wizklubCallBacks}>
                          {" "}
                          Call Backs
                        </Link>
                      </li>
                    ) : r1 === 6 ? (
                      <li className="breadcrumb-item">
                        <Link to={routes.wizklubTrainerStudents}>
                          {" "}
                          Trainer Students
                        </Link>
                      </li>
                    )
                      : r1 === 7 ? (
                        <li className="breadcrumb-item">
                          <Link to={routes.wizklubTrainerFollowUpStudents}>
                            {" "}
                            Trainer Follow up Students
                          </Link>
                        </li>
                      )
                        : r1 === 8 ? (
                          <li className="breadcrumb-item">
                            <Link to={routes.wizklubTrainerDailedStudents}>
                              {" "}
                              Trainer Students
                            </Link>
                          </li>
                        ) : r1 === 9 ? (
                          <li className="breadcrumb-item">
                            <Link to={routes.wizklubCallLogs}>
                              {" "}
                              Call Logs
                            </Link>
                          </li>
                        ) : r1 === 10 ? (
                          <li className="breadcrumb-item">
                            <Link to={routes.wizklubTrainerSales}>
                              {" "}
                              Trainer Sales
                            </Link>
                          </li>
                        ) : r1 === 11 ? (
                          <li className="breadcrumb-item">
                            <Link to={routes.wizklubOneYearPreviousYearStudents}>
                              {" "}
                              Renewal Students(2024-2025)
                            </Link>
                          </li>
                        )
                        : r1 === 12 ? (
                          <li className="breadcrumb-item">
                            <Link to={routes.wizklubSalesAnalytics}>
                              {" "}
                              Sale Analytics
                            </Link>
                          </li>
                        ) : null}
                  <li className="breadcrumb-item active">{newAdmin.button}</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Non-editable Fields Card */}
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                height: "100vh",
                paddingTop: "20px",
              }}
            >
              <Spin /> {/* Display loader while loading */}
            </div>
          ) : (
            <div>
              <div
                className="card"
                style={{
                  width: "25%",
                  margin: "5px",
                  float: "left",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  borderRadius: "12px",
                  // background: "linear-gradient(135deg, #e0f7fa, #f3e5f5)",
                  border: "1px solid #d1d5db",
                }}
              >
                <div className="card-body">
                  {/* <img
                    src="https://cdn-icons-png.flaticon.com/128/4466/4466375.png"
                    alt="Higher Education Illustration"
                    style={{
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "80%",
                      borderRadius: "12px",
                    }}
                  /> */}
                  {/* <h5
                    className="card-title"
                    style={{ fontWeight: "bold", marginBottom: "15px" }}
                  >
                    Student Details
                  </h5> */}
                  {/* Details Rows */}

                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      SCS Number:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.SCS_Number}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Student:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Branch:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.branch_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Orientation:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.orientation_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Class:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.student_class_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Enrolling Class:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.enrolling_class_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Section:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.section_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Academic Year:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.academic_year_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      No. of Updates:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.no_of_attempts}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Agent:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.agent_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Wizklub Branch:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.is_wizklub_branch ? "Yes" : "No"}
                    </span>
                  </div>
                  {/* <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Offline Branch:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.is_offline_branch ? "Yes" : "No"}
                    </span>
                  </div> */}
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Paid Last Year:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.is_wizklub_paid_last_year ? "Yes" : "No"}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Admission Status:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.admission_status_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Wizklub Paid:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.is_wizklub_paid ? "Yes" : "No"}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                      Phone Number:
                    </span>
                    <span
                      style={{
                        textAlign: "right",
                        color: "#1f2937",
                        cursor: "pointer",
                      }}
                      onClick={toggleLock}
                    >
                      {isLocked ? (
                        <span role="img" aria-label="locked">
                          &#128274; {/* Closed lock icon */}
                        </span>
                      ) : (
                        phoneNumber || (
                          <span role="img" aria-label="unlocked">
                            &#128275; {/* Open lock icon */}
                          </span>
                        )
                      )}
                    </span>
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <a href="#" onClick={() => openModal()} style={{ color: "#2563eb", textDecoration: "underline" }}>
                      Add Custom Phone Number
                    </a>
                  </div>
                  {contacts.map((contact) => (
                    <div
                      key={contact.id}
                      style={{ padding: "8px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                    >
                      <div>
                        <strong>{contact.relation_type_name}</strong>: {contact.name} ({contact.phone_number})
                      </div>
                      <button className="btn btn-sm btn-outline-primary" onClick={() => openModal(contact)}>
                        Edit
                      </button>
                    </div>
                  ))}

                  <h5
                    style={{
                      marginTop: "15px",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Siblings
                  </h5>
                  {sibiling?.map((sibling, index) => (
                    <div
                      key={index}
                      style={{
                        margin: "10px",
                        padding: "15px",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          SCS Number:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                        >
                          {sibling.SCS_Number}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          Student Name:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                        >
                          {sibling.name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          Admission Status:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                        >
                          {sibling.admission_status_name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          Branch:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                        >
                          {sibling.branch_name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          Orientation:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                        >
                          {sibling.orientation_name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          Class:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                        >
                          {sibling.student_class_name}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          Wizklub paid last year:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                        >
                          {sibling.is_wizklub_paid_last_year ? "Yes" : "No"}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          Wizklub Paid:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                        >
                          {sibling.is_wizklub_paid ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Update Ticket and Ticket Logs Buttons */}
              <div
                className="row justify-content-center"
                style={{
                  marginTop: "20px",
                  marginBottom: "15px",
                  marginLeft: "5px",
                }}
              >
                <div className="col-sm-12 d-flex justify-content-between">
                  <div>
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleToggleForm}
                    >
                      {newAdmin.button}
                    </button>
                    {/* <button
                      className="btn btn-primary me-2"
                      onClick={handleToggleCallHistory}
                    >
                      Call History
                    </button> */}

                    {checkPermission(
                      "view_wizklubticketlog",
                      "wizklubticketlog"
                    ) && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={() =>
                            ticket_id && handleToggleTicketLogs(ticket_id)
                          }
                        >
                          {ticketLogLoading ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>TicketLog</>
                          )}
                        </button>
                      )}

                    {checkPermission("view_calllog", "calllog") && (
                      <button
                        className="btn btn-primary"
                        onClick={handleToggleCallLogs}
                      >
                        {callLogLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Call Log</>
                        )}
                      </button>
                    )}
                  </div>
                  <div>
                    {checkPermission("can_call", "Call") && (
                      <button
                        className="btn btn-success me-2"
                        style={{ backgroundColor: "#28a745", color: "white" }}
                        // onClick={() => {
                        //   if (
                        //     window.confirm(
                        //       "Are you sure want to make this call?"
                        //     )
                        //   ) {
                        //     handleCallClick();
                        //   }
                        // }}
                        onClick={handleCallButtonClick}
                        data-bs-toggle="modal"
                        data-bs-target="#call_confirmation_modal"
                        disabled={isLoading || isCalling}
                      >
                        {callLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>
                            <i className="ti ti-phone"></i> Call
                          </>
                        )}
                      </button>
                    )}

                    {checkPermission("can_whatapp", "WhatsApp") && (
                      <button
                        className="btn btn-success me-2"
                        style={{ backgroundColor: "#25D366", color: "white" }}
                        data-bs-toggle="modal"
                        data-bs-target="#whatsapp_confirmation_modal"
                        disabled={whatsappLoading}
                      >
                        {messageLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>
                            <i className="ti ti-brand-whatsapp"></i> WhatsApp
                          </>
                        )}
                      </button>
                    )}
                    {checkPermission("can_message", "Message") && (
                      <button
                        className="btn btn-success"
                        style={{ backgroundColor: "#007bff", color: "white" }}
                        data-bs-toggle="modal"
                        data-bs-target="#message_confirmation_modal"
                        disabled={messageLoading}
                      >
                        {messageLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>
                            <i className="ti ti-message"></i> TextMessage
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Editable Form */}
              {showForm && (
                <div className="row justify-content-center">
                  <div className="col-sm-12 d-flex justify-content-center">
                    <div
                      className="card"
                      style={{
                        position: "relative", // Required for positioning the Agent badge
                        width: "100%",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        borderRadius: "12px",
                        padding: "20px",
                        backgroundColor: "#fff",
                        border: "1px solid #d1d5db",
                      }}
                    >
                      {/* 🔷 Agent Badge */}
                      {trianer_or_agent?.is_trainer && (
                        <div
                          style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            backgroundColor: "#d0ebff",
                            padding: "6px 12px",
                            borderRadius: "8px",
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#004085",
                            border: "1px solid #b8daff",
                            zIndex: 10,
                          }}
                        >
                          {trianer_or_agent.is_trainer}
                        </div>
                      )}

                      <div className="card-body">
                        <form onSubmit={handleSubmit}>
                          <div
                            className="modal-body light-violet-bg d-flex"
                            style={{ flexWrap: "wrap" }}
                          >
                            <div
                              className="mb-3 me-3"
                              style={{
                                flex: "1 1 100%",
                                maxWidth: "300px",
                                marginRight: "15px",
                                width: "300px",
                              }}
                            >
                              <label className="form-label">Category</label>
                              <CommonSelect
                                className="select"
                                options={categoryOptions}
                                onChange={handleCategoryChange}
                                value={selectedCategory}
                                isRequired
                              />
                            </div>

                            {showCallBackTime && (
                              <div
                                className="form-group mb-3"
                                style={{
                                  width: "300px",
                                  maxWidth: "300px",
                                  marginRight: "15px",
                                  position: "relative",
                                }}
                              >
                                <label className="form-label">Call Back Time</label>
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  name="call_back_time"
                                  placeholder="Call Back Time"
                                  onChange={handleInputChange}
                                  value={newTicket.call_back_time || ""}
                                  required
                                  min={new Date().toISOString().slice(0, 16)}
                                  onFocus={() => {
                                    const doneText = document.getElementById("doneText");
                                    if (doneText) doneText.style.display = "inline";
                                  }}
                                  onBlur={() => {
                                    const doneText = document.getElementById("doneText");
                                    if (doneText) doneText.style.display = "none";
                                  }}
                                />
                                <small
                                  id="doneText"
                                  className="text-primary"
                                  style={{
                                    cursor: "pointer",
                                    position: "absolute",
                                    right: "10px",
                                    top: "5px",
                                    display: "none",
                                  }}
                                  onClick={() => {
                                    const inputElement =
                                      document.querySelector<HTMLInputElement>(
                                        'input[name="callbacktime"]'
                                      );
                                    if (inputElement) inputElement.blur();
                                  }}
                                >
                                  Done
                                </small>
                              </div>
                            )}

                            <div
                              className="mb-3"
                              style={{
                                flex: "1 1 100%",
                                maxWidth: "300px",
                                marginRight: "15px",
                                width: "300px",
                              }}
                            >
                              <label className="form-label">Sub-Category</label>
                              <CommonSelect
                                className="select"
                                options={subCategoryOptions}
                                onChange={handleSubCategoryChange}
                                value={selectedSubCategory}
                              />
                            </div>

                            <div
                              className="mb-3 me-3"
                              style={{
                                flex: "1 1 100%",
                                maxWidth: "300px",
                                marginRight: "15px",
                                width: "300px",
                              }}
                            >
                              <label className="form-label">Priority</label>
                              <CommonSelect
                                className="select"
                                options={priorityOptions}
                                onChange={handlePriorityChange}
                                value={selectedPriority}
                                isRequired
                              />
                            </div>

                            <div
                              className="form-group mb-3"
                              style={{ flex: "1 1 100%", minWidth: "200px" }}
                            >
                              <label className="form-label">Description</label>
                              <textarea
                                className="form-control"
                                name="description"
                                placeholder="Description"
                                onChange={handleInputChange}
                                value={newTicket.description || ""}
                                rows={4}
                              />
                            </div>
                          </div>

                          <div className="modal-footer">
                            {/* <Link
                              className="btn btn-primary"
                              to={routes.SummerCampStudents}
                              style={{
                                backgroundColor: "lightcoral",
                                color: "white",
                                marginRight: "5px",
                              }}
                            >
                              Cancel
                            </Link> */}
                            <OverlayTrigger
                              show={showPopover}
                              placement="top"
                              overlay={popoverWarning}
                              trigger="click"
                            >
                              <button
                                className="btn btn-primary"
                                type={isCalling ? "button" : "submit"}
                                disabled={isLoading}
                                onClick={() => {
                                  if (isCalling) {
                                    setShowPopover(true);
                                    setTimeout(() => setShowPopover(false), 3000);
                                  }
                                }}
                              >
                                {isLoading ? (
                                  <i className="spinner-border spinner-border-sm"></i>
                                ) : (
                                  <>Save</>
                                )}
                              </button>
                            </OverlayTrigger>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {/* Ticket Logs */}
              {showTicketLogs && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <ul
                          className="timeline"
                          style={{
                            position: "relative",
                            paddingLeft: "0",
                            listStyle: "none",
                          }}
                        >
                          <div
                            style={{
                              content: "",
                              position: "absolute",
                              top: "0",
                              bottom: "0",
                              width: "4px",
                              background: "#e9ecef",
                              left: "50%",
                              marginLeft: "-2px",
                            }}
                          ></div>
                          {ticketLogs.map((log, index) => (
                            <li
                              key={index}
                              className={
                                index % 2 === 0 ? "" : "timeline-inverted"
                              }
                              style={{
                                position: "relative",
                                marginBottom: "10px",
                              }}
                            >
                              <div
                                className="card timeline-card"
                                style={{
                                  background:
                                    index % 2 === 0 ? "#add8e6" : "#e6e6fa",
                                  padding: "10px",
                                  borderRadius: "95px",
                                  cursor: "pointer",
                                  overflowX: "auto",
                                  // width: "auto",
                                  // display: "inline-block",
                                  // marginLeft: "50%", // Center the card
                                  // transform: "translateX(-50%)",
                                }}
                                onClick={() => handleToggleLog(index)}
                              >
                                <div
                                  className="timeline-heading"
                                  style={{
                                    textAlign: "center",
                                    position: "relative",
                                    zIndex: "101",
                                    whiteSpace: "nowrap",
                                    overflowX: "auto",
                                  }}
                                >
                                  <h5
                                    className="timeline-title"
                                    style={{ margin: "0" }}
                                  >
                                    {log.heading}
                                  </h5>
                                </div>
                              </div>
                              {expandedLogs[index] && (
                                <div
                                  className="timeline-panel"
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    float: index % 2 === 0 ? "left" : "right",
                                    padding: "20px",
                                    border: "1px solid #d4d4d4",
                                    borderRadius: "2px",
                                    background: "#fff",
                                    boxShadow: "0 1px 6px rgba(0, 0, 0, 0.175)",
                                    overflowX: "auto",
                                  }}
                                >
                                  <div className="timeline-heading">
                                    <h4 className="timeline-title">
                                      {log.student_name}
                                    </h4>
                                  </div>
                                  <div className="timeline-body">
                                    <table
                                      style={{
                                        width: "100%",
                                        tableLayout: "fixed",
                                        borderCollapse: "collapse",
                                      }}
                                    >
                                      <tbody>
                                        {log.description && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Description:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.description}
                                            </td>
                                          </tr>
                                        )}
                                        {log.category_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Category:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.category_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.subcategory_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Sub-Category:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.subcategory_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.ticket_type_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Ticket Type:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.ticket_type_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.priority_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Priority:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.priority_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.disposition_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Disposition:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.disposition_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.resolve_notes && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Resolve Notes:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.resolve_notes}
                                            </td>
                                          </tr>
                                        )}
                                        {log.remarks && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Remarks:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.remarks}
                                            </td>
                                          </tr>
                                        )}
                                        {log.call_back_time && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Call Back Time:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {new Date(
                                                log.call_back_time
                                              ).toLocaleString()}
                                            </td>
                                          </tr>
                                        )}
                                        {log.call_start_time && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Call Start Time:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {new Date(
                                                log.call_start_time
                                              ).toLocaleString()}
                                            </td>
                                          </tr>
                                        )}
                                        {log.updated_by_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Updated By:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.updated_by_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.is_ticket_by_trainer && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Trainer_Or_Agent:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.is_ticket_by_trainer}
                                            </td>
                                          </tr>
                                        )}
                                        {log.updated_at && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Updated At:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {new Date(
                                                log.updated_at
                                              ).toLocaleString()}
                                            </td>
                                          </tr>
                                        )}
                                        {log.call_logs &&
                                          log.call_logs.map(
                                            (
                                              call: {
                                                aws_call_recording_file: string;
                                                caller_status: string;
                                                destination_status: string;
                                                call_start_time_:
                                                | string
                                                | number
                                                | Date;
                                                call_end_time_:
                                                | string
                                                | number
                                                | Date;
                                                agent_name:
                                                | string
                                                | number
                                                | boolean
                                                | React.ReactElement<
                                                  any,
                                                  | string
                                                  | React.JSXElementConstructor<any>
                                                >
                                                | Iterable<React.ReactNode>
                                                | React.ReactPortal
                                                | null
                                                | undefined;
                                                call_duration_hms:
                                                | string
                                                | number
                                                | boolean
                                                | React.ReactElement<
                                                  any,
                                                  | string
                                                  | React.JSXElementConstructor<any>
                                                >
                                                | Iterable<React.ReactNode>
                                                | React.ReactPortal
                                                | null
                                                | undefined;
                                                conversation_duration_hms:
                                                | string
                                                | number
                                                | boolean
                                                | React.ReactElement<
                                                  any,
                                                  | string
                                                  | React.JSXElementConstructor<any>
                                                >
                                                | Iterable<React.ReactNode>
                                                | React.ReactPortal
                                                | null
                                                | undefined;
                                              },
                                              callIndex:
                                                | React.Key
                                                | null
                                                | undefined
                                            ) => {
                                              // Determine if the caller and destination answered
                                              const isCallerAnswered =
                                                call.caller_status.toLowerCase() ===
                                                "answered";
                                              const isDestinationAnswered =
                                                call.destination_status.toLowerCase() ===
                                                "answered";

                                              // Set badge color based on call status
                                              const badgeColor =
                                                isCallerAnswered &&
                                                  isDestinationAnswered
                                                  ? "success"
                                                  : "danger";

                                              // Set icon based on whether the call was answered or not
                                              const agentIcon = isCallerAnswered
                                                ? "fas fa-phone text-success"
                                                : "fas fa-phone text-danger";
                                              const studentIcon =
                                                isDestinationAnswered
                                                  ? "fas fa-phone text-success"
                                                  : "fas fa-phone text-danger";

                                              return (
                                                <tr key={callIndex}>
                                                  {call.call_start_time_ && (
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border:
                                                          "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Call Start:
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "green",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        {new Date(
                                                          call.call_start_time_
                                                        ).toLocaleString()}
                                                      </span>
                                                    </td>
                                                  )}
                                                  {call.call_end_time_ && (
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border:
                                                          "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Call End:
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "red",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        {new Date(
                                                          call.call_end_time_
                                                        ).toLocaleString()}
                                                      </span>
                                                    </td>
                                                  )}
                                                  <td
                                                    style={{
                                                      border:
                                                        "1px solid #d4d4d4",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "inline-block",
                                                        marginRight: "30px",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <h4 className="timeline-title">
                                                        {call.agent_name}{" "}
                                                        <i
                                                          className={agentIcon}
                                                        ></i>
                                                      </h4>
                                                      {call.call_duration_hms && (
                                                        <p
                                                          style={{
                                                            color: "orange",
                                                            marginBottom: "3px",
                                                          }}
                                                        >
                                                          {
                                                            call.call_duration_hms
                                                          }
                                                        </p>
                                                      )}
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "inline-block",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <h5 className="timeline-title">
                                                        PARENT{" "}
                                                        <i
                                                          className={
                                                            studentIcon
                                                          }
                                                        ></i>
                                                      </h5>
                                                      {call.conversation_duration_hms && (
                                                        <p
                                                          style={{
                                                            color: "orange",
                                                          }}
                                                        >
                                                          {
                                                            call.conversation_duration_hms
                                                          }
                                                        </p>
                                                      )}
                                                    </div>
                                                    {call.aws_call_recording_file && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "flex-end",
                                                          marginTop: "10px", // Optional: Adds some spacing above the audio player
                                                        }}
                                                      >
                                                        <AudioPlayer
                                                          src={
                                                            call.aws_call_recording_file
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showTicketLogs && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <h1 className="d-flex justify-content-center me-1">Previous Year Ticket Logs</h1>
                        <ul
                          className="timeline"
                          style={{
                            position: "relative",
                            paddingLeft: "0",
                            listStyle: "none",
                          }}
                        >

                          <div
                            style={{
                              content: "",
                              position: "absolute",
                              top: "0",
                              bottom: "0",
                              width: "4px",
                              background: "#e9ecef",
                              left: "50%",
                              marginLeft: "-2px",
                            }}
                          ></div>
                          {previousYearTicketLogs.map((log, index) => (
                            <li
                              key={index}
                              className={
                                index % 2 === 0 ? "" : "timeline-inverted"
                              }
                              style={{
                                position: "relative",
                                marginBottom: "10px",
                              }}
                            >
                              <div
                                className="card timeline-card"
                                style={{
                                  background:
                                    index % 2 === 0 ? "#add8e6" : "#e6e6fa",
                                  padding: "10px",
                                  borderRadius: "95px",
                                  cursor: "pointer",
                                  overflowX: "auto",
                                  // width: "auto",
                                  // display: "inline-block",
                                  // marginLeft: "50%", // Center the card
                                  // transform: "translateX(-50%)",
                                }}
                                onClick={() => handleToggleLog1(index)}
                              >
                                <div
                                  className="timeline-heading"
                                  style={{
                                    textAlign: "center",
                                    position: "relative",
                                    zIndex: "101",
                                    whiteSpace: "nowrap",
                                    overflowX: "auto",
                                  }}
                                >
                                  <h5
                                    className="timeline-title"
                                    style={{ margin: "0" }}
                                  >
                                    {log.heading}
                                  </h5>
                                </div>
                              </div>
                              {expandedLogs1[index] && (
                                <div
                                  className="timeline-panel"
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    float: index % 2 === 0 ? "left" : "right",
                                    padding: "20px",
                                    border: "1px solid #d4d4d4",
                                    borderRadius: "2px",
                                    background: "#fff",
                                    boxShadow: "0 1px 6px rgba(0, 0, 0, 0.175)",
                                    overflowX: "auto",
                                  }}
                                >
                                  <div className="timeline-heading">
                                    <h4 className="timeline-title">
                                      {log.student_name}
                                    </h4>
                                  </div>
                                  <div className="timeline-body">
                                    <table
                                      style={{
                                        width: "100%",
                                        tableLayout: "fixed",
                                        borderCollapse: "collapse",
                                      }}
                                    >
                                      <tbody>
                                        {log.description && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Description:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.description}
                                            </td>
                                          </tr>
                                        )}
                                        {log.category_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Category:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.category_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.subcategory_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Sub-Category:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.subcategory_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.ticket_type_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Ticket Type:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.ticket_type_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.priority_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Priority:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.priority_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.disposition_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Disposition:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.disposition_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.resolve_notes && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Resolve Notes:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.resolve_notes}
                                            </td>
                                          </tr>
                                        )}
                                        {log.remarks && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Remarks:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.remarks}
                                            </td>
                                          </tr>
                                        )}
                                        {log.call_back_time && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Call Back Time:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {new Date(
                                                log.call_back_time
                                              ).toLocaleString()}
                                            </td>
                                          </tr>
                                        )}
                                        {log.call_start_time && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Call Start Time:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {new Date(
                                                log.call_start_time
                                              ).toLocaleString()}
                                            </td>
                                          </tr>
                                        )}
                                        {log.updated_by_name && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Updated By:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.updated_by_name}
                                            </td>
                                          </tr>
                                        )}
                                        {log.is_ticket_by_trainer && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Trainer_Or_Agent:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {log.is_ticket_by_trainer}
                                            </td>
                                          </tr>
                                        )}
                                        {log.updated_at && (
                                          <tr>
                                            <td
                                              style={{
                                                fontWeight: "bold",
                                                border: "1px solid #d4d4d4",
                                                whiteSpace: "nowrap",
                                                padding: "8px",
                                              }}
                                            >
                                              Updated At:
                                            </td>
                                            <td
                                              style={{
                                                border: "1px solid #d4d4d4",
                                                overflowX: "auto",
                                                padding: "8px",
                                              }}
                                            >
                                              {new Date(
                                                log.updated_at
                                              ).toLocaleString()}
                                            </td>
                                          </tr>
                                        )}
                                        {log.call_logs &&
                                          log.call_logs.map(
                                            (
                                              call: {
                                                aws_call_recording_file: string;
                                                caller_status: string;
                                                destination_status: string;
                                                call_start_time_:
                                                | string
                                                | number
                                                | Date;
                                                call_end_time_:
                                                | string
                                                | number
                                                | Date;
                                                agent_name:
                                                | string
                                                | number
                                                | boolean
                                                | React.ReactElement<
                                                  any,
                                                  | string
                                                  | React.JSXElementConstructor<any>
                                                >
                                                | Iterable<React.ReactNode>
                                                | React.ReactPortal
                                                | null
                                                | undefined;
                                                call_duration_hms:
                                                | string
                                                | number
                                                | boolean
                                                | React.ReactElement<
                                                  any,
                                                  | string
                                                  | React.JSXElementConstructor<any>
                                                >
                                                | Iterable<React.ReactNode>
                                                | React.ReactPortal
                                                | null
                                                | undefined;
                                                conversation_duration_hms:
                                                | string
                                                | number
                                                | boolean
                                                | React.ReactElement<
                                                  any,
                                                  | string
                                                  | React.JSXElementConstructor<any>
                                                >
                                                | Iterable<React.ReactNode>
                                                | React.ReactPortal
                                                | null
                                                | undefined;
                                              },
                                              callIndex:
                                                | React.Key
                                                | null
                                                | undefined
                                            ) => {
                                              // Determine if the caller and destination answered
                                              const isCallerAnswered =
                                                call.caller_status.toLowerCase() ===
                                                "answered";
                                              const isDestinationAnswered =
                                                call.destination_status.toLowerCase() ===
                                                "answered";

                                              // Set badge color based on call status
                                              const badgeColor =
                                                isCallerAnswered &&
                                                  isDestinationAnswered
                                                  ? "success"
                                                  : "danger";

                                              // Set icon based on whether the call was answered or not
                                              const agentIcon = isCallerAnswered
                                                ? "fas fa-phone text-success"
                                                : "fas fa-phone text-danger";
                                              const studentIcon =
                                                isDestinationAnswered
                                                  ? "fas fa-phone text-success"
                                                  : "fas fa-phone text-danger";

                                              return (
                                                <tr key={callIndex}>
                                                  {call.call_start_time_ && (
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border:
                                                          "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Call Start:
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "green",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        {new Date(
                                                          call.call_start_time_
                                                        ).toLocaleString()}
                                                      </span>
                                                    </td>
                                                  )}
                                                  {call.call_end_time_ && (
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border:
                                                          "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Call End:
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "red",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        {new Date(
                                                          call.call_end_time_
                                                        ).toLocaleString()}
                                                      </span>
                                                    </td>
                                                  )}
                                                  <td
                                                    style={{
                                                      border:
                                                        "1px solid #d4d4d4",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "inline-block",
                                                        marginRight: "30px",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <h4 className="timeline-title">
                                                        {call.agent_name}{" "}
                                                        <i
                                                          className={agentIcon}
                                                        ></i>
                                                      </h4>
                                                      {call.call_duration_hms && (
                                                        <p
                                                          style={{
                                                            color: "orange",
                                                            marginBottom: "3px",
                                                          }}
                                                        >
                                                          {
                                                            call.call_duration_hms
                                                          }
                                                        </p>
                                                      )}
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "inline-block",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <h5 className="timeline-title">
                                                        PARENT{" "}
                                                        <i
                                                          className={
                                                            studentIcon
                                                          }
                                                        ></i>
                                                      </h5>
                                                      {call.conversation_duration_hms && (
                                                        <p
                                                          style={{
                                                            color: "orange",
                                                          }}
                                                        >
                                                          {
                                                            call.conversation_duration_hms
                                                          }
                                                        </p>
                                                      )}
                                                    </div>
                                                    {call.aws_call_recording_file && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "flex-end",
                                                          marginTop: "10px", // Optional: Adds some spacing above the audio player
                                                        }}
                                                      >
                                                        <AudioPlayer
                                                          src={
                                                            call.aws_call_recording_file
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Call Logs */}
              {showCallLogs && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <ul className="timeline">
                          {callLogs.map((call, index) => {
                            const isCallerAnswered =
                              call.caller_status.toLowerCase() === "answered";
                            const isDestinationAnswered =
                              call.destination_status.toLowerCase() ===
                              "answered";
                            const badgeColor =
                              isCallerAnswered && isDestinationAnswered
                                ? "success"
                                : "danger";
                            const agentIcon = isCallerAnswered
                              ? "fas fa-phone text-success"
                              : "fas fa-phone text-danger";
                            const studentIcon = isDestinationAnswered
                              ? "fas fa-phone text-success"
                              : "fas fa-phone text-danger";

                            return (
                              <li
                                key={index}
                                className={
                                  index % 2 === 0 ? "" : "timeline-inverted"
                                }
                              >
                                <div className={`timeline-badge ${badgeColor}`}>
                                  <i className="fas fa-phone" />
                                </div>
                                <div
                                  className="timeline-panel"
                                  style={{
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.1)", // Shadow effect
                                    borderRadius: "5px", // Optional: Rounds the corners of the card
                                  }}
                                >
                                  <div className="timeline-heading">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {call.call_start_time_ && (
                                        <span
                                          style={{
                                            color: "green",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {new Date(
                                            call.call_start_time_
                                          ).toLocaleString()}
                                        </span>
                                      )}
                                      {call.call_end_time_ && (
                                        <span
                                          style={{
                                            color: "red",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {new Date(
                                            call.call_end_time_
                                          ).toLocaleString()}
                                        </span>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "inline-block",
                                          marginRight: "30px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <h4 className="timeline-title">
                                          {call.agent_name}{" "}
                                          <i className={agentIcon}></i>
                                        </h4>
                                        {call.call_duration_hms && (
                                          <p
                                            style={{
                                              color: "orange",
                                              marginBottom: "3px",
                                            }}
                                          >
                                            {call.call_duration_hms}
                                          </p>
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          display: "inline-block",
                                          textAlign: "center",
                                        }}
                                      >
                                        <h5 className="timeline-title">
                                          PARENT <i className={studentIcon}></i>
                                        </h5>
                                        {call.conversation_duration_hms && (
                                          <p style={{ color: "orange" }}>
                                            {call.conversation_duration_hms}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="timeline-body">
                                    {call.aws_call_recording_file && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <AudioPlayer
                                          src={call.aws_call_recording_file}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showCallLogs && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <h1 className="d-flex justify-content-center">Previous Year Call Logs</h1>
                        <ul className="timeline">
                          {previousYearCallLogs.map((call, index) => {
                            const isCallerAnswered =
                              call.caller_status.toLowerCase() === "answered";
                            const isDestinationAnswered =
                              call.destination_status.toLowerCase() ===
                              "answered";
                            const badgeColor =
                              isCallerAnswered && isDestinationAnswered
                                ? "success"
                                : "danger";
                            const agentIcon = isCallerAnswered
                              ? "fas fa-phone text-success"
                              : "fas fa-phone text-danger";
                            const studentIcon = isDestinationAnswered
                              ? "fas fa-phone text-success"
                              : "fas fa-phone text-danger";

                            return (
                              <li
                                key={index}
                                className={
                                  index % 2 === 0 ? "" : "timeline-inverted"
                                }
                              >
                                <div className={`timeline-badge ${badgeColor}`}>
                                  <i className="fas fa-phone" />
                                </div>
                                <div
                                  className="timeline-panel"
                                  style={{
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.1)", // Shadow effect
                                    borderRadius: "5px", // Optional: Rounds the corners of the card
                                  }}
                                >
                                  <div className="timeline-heading">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {call.call_start_time_ && (
                                        <span
                                          style={{
                                            color: "green",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {new Date(
                                            call.call_start_time_
                                          ).toLocaleString()}
                                        </span>
                                      )}
                                      {call.call_end_time_ && (
                                        <span
                                          style={{
                                            color: "red",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {new Date(
                                            call.call_end_time_
                                          ).toLocaleString()}
                                        </span>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "inline-block",
                                          marginRight: "30px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <h4 className="timeline-title">
                                          {call.agent_name}{" "}
                                          <i className={agentIcon}></i>
                                        </h4>
                                        {call.call_duration_hms && (
                                          <p
                                            style={{
                                              color: "orange",
                                              marginBottom: "3px",
                                            }}
                                          >
                                            {call.call_duration_hms}
                                          </p>
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          display: "inline-block",
                                          textAlign: "center",
                                        }}
                                      >
                                        <h5 className="timeline-title">
                                          PARENT <i className={studentIcon}></i>
                                        </h5>
                                        {call.conversation_duration_hms && (
                                          <p style={{ color: "orange" }}>
                                            {call.conversation_duration_hms}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="timeline-body">
                                    {call.aws_call_recording_file && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <AudioPlayer
                                          src={call.aws_call_recording_file}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {isCalling && (
            <div
              style={{
                position: "fixed",
                top: "65px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "5px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "10px 15px", // reduced padding
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                fontSize: "0.9em", // reduced font size
                animation: "ringing 1s infinite",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "10px", // tighter spacing
                }}
              >
                <i
                  className="ti ti-phone"
                  style={{
                    fontSize: "1.2em", // reduced icon size
                    color: "blue",
                    marginRight: "5px",
                    animation: "ringing 1s infinite",
                  }}
                ></i>
                <span style={{ animation: "ringing 1s infinite" }}>
                  Calling {newAdmin.name} - {Math.floor(callDuration / 60)}:
                  {("0" + (callDuration % 60)).slice(-2)}
                </span>
              </div>
              <button
                className="btn btn-danger btn-sm" // smaller button
                style={{
                  backgroundColor: "#dc3545",
                  color: "white",
                  padding: "5px 10px", // reduced padding
                  fontSize: "0.85em", // smaller text
                }}
                onClick={handleEndCallClick}
              >
                <i className="ti ti-phone-off" style={{ fontSize: "1.2em" }}></i>
              </button>
            </div>
          )}

          {showCard && (
            <div className="row justify-content-center">
              <div className="col-md-12 d-flex justify-content-center">
                <div
                  className="card"
                  style={{
                    width: "100%",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    // padding: "20px",
                    backgroundColor: "#fff",
                    border: "1px solid #d1d5db",
                  }}
                >
                  <div className="card-body">
                    <select
                      value={selectedScript}
                      onChange={handleSelectChange}
                      style={{ marginBottom: "5px" }}
                    >
                      <option value="">Select a script</option>
                      {scriptDropdown.map((item) => (
                        <option key={item.script_id} value={item.script_id}>
                          {item.script_name}
                        </option>
                      ))}
                    </select>
                    {pdfUrl && (
                      <div>
                        <embed
                          src={pdfUrl}
                          type="application/pdf"
                          width="100%"
                          height="1100px"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          {/* /Row */}
        </div>

        <div style={containerStyle}>
          {checkPermission("view_script", "script") && (
            <img
              src="https://cdn-icons-png.freepik.com/256/14955/14955846.png?ga=GA1.1.568823308.1733236272&semt=ais_hybrid"
              alt="Chat Script"
              title="Chat Script"
              style={{
                width: "50px",
                height: "50px",
                cursor: "pointer",
                marginBottom: "10px",
              }}
              onClick={toggleCard}
            />
          )}
          {/* <FontAwesomeIcon
            icon={faTrophy as IconProp}
            title="Leaderboard"
            style={iconStyles.leaderboard}
          />
          <FontAwesomeIcon
            icon={faComments as IconProp}
            title="Chat"
            style={iconStyles.chat}
          /> */}
        </div>
        <div
          className="modal fade"
          id="call_confirmation_modal"
          // tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm Call</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label>Select Number</label>
                  <select
                    className="form-select"
                    value={selectedCallId}
                    onChange={(e) => setSelectedCallId(e.target.value)}
                  >
                    <option value="">Select contact</option>
                    {callOptions.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <p>Are you sure you want to make this call?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  style={{ marginRight: "9px" }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={handleCallClick}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="message_confirmation_modal"
          // tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm Message</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to send text message?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  style={{ marginRight: "9px" }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={handleMessageClick}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        {showModal && (
          <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">{editingId ? "Edit Contact" : "Add Contact"}</h4>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label>Relation Type</label>
                    <select
                      className="form-select"
                      value={formData.relation_type || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, relation_type: parseInt(e.target.value, 10) })
                      }
                    >
                      <option value="">Select Relation</option>
                      {relationTypes.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label>Name (Optional)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.name || ""}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      className="form-control"
                      value={formData.phone_number || ""}
                      onChange={(e) => setFormData({ ...formData, phone_number: e.target.value })}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-danger"
                    style={{ marginRight: "10px" }}
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-success" onClick={handleCustomModelSubmit}>
                    {editingId ? "Update" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className="modal fade"
          id="whatsapp_confirmation_modal"
          // tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm Message</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to send Whatsapp message?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  style={{ marginRight: "9px" }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={handleWhasappClick}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  function formatKey(key: string) {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char: string) => char.toUpperCase());
  }
};

export default AddOrUpdateWizklubTicket;
